import React, { useState } from 'react';
import { TriggerBongoHit } from './../../../utilities/DL/Bongo';

/**
 * COMPONENTE: BONGO MOBILE CONTROLLER (CONTROL REMOTO INTERACTIVO PARA AFICIONADOS)
 * ---------------------------------------------------------------------------------
 * Pantalla táctil de baja latencia con respuesta háptica y animaciones aceleradas.
 * ---------------------------------------------------------------------------------
 */
export const BongoMobile = () => {
    const [leftActive, setLeftActive] = useState(false);
    const [rightActive, setRightActive] = useState(false);

    // Ejecuta golpe de bongo
    const handleHit = async (side) => {
        // Respuesta táctil: vibrar 30ms (háptica celular)
        if (navigator.vibrate) {
            navigator.vibrate(35);
        }

        // Animación de rebote local
        if (side === 'left') {
            setLeftActive(true);
            setTimeout(() => setLeftActive(false), 80);
        } else {
            setRightActive(true);
            setTimeout(() => setRightActive(false), 80);
        }

        // Transmitir señal HTTP a la API de inmediato (baja latencia)
        await TriggerBongoHit(side);
    };

    return (
        <div className="bongo-mobile-container">
            <style>{`
                .bongo-mobile-container {
                    position: fixed;
                    top: 0; left: 0;
                    width: 100vw; height: 100vh;
                    background: linear-gradient(135deg, #0b0d19 0%, #151a30 100%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    font-family: 'Orbitron', sans-serif;
                    color: #ffffff;
                    padding: 4vh 5vw;
                    box-sizing: border-box;
                    user-select: none;
                    touch-action: manipulation;
                }

                .bongo-mobile-header {
                    text-align: center;
                    margin-top: 2vh;
                }

                .bongo-mobile-title {
                    font-size: 2.2rem;
                    font-weight: 900;
                    letter-spacing: 4px;
                    margin: 0;
                    text-transform: uppercase;
                    background: linear-gradient(90deg, #00ffff 0%, #ff00ff 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    text-shadow: 0 0 15px rgba(0, 255, 255, 0.3);
                }

                .bongo-mobile-subtitle {
                    font-size: 0.9rem;
                    opacity: 0.6;
                    margin-top: 1vh;
                    letter-spacing: 1px;
                }

                /* Contenedor de bongos táctiles */
                .bongo-mobile-pads {
                    display: flex;
                    width: 100%;
                    gap: 5vw;
                    flex: 1;
                    align-items: center;
                    justify-content: center;
                    padding: 4vh 0;
                }

                .bongo-touch-pad {
                    flex: 1;
                    height: 50vh;
                    max-width: 220px;
                    background: rgba(255, 255, 255, 0.03);
                    border: 2px solid rgba(255, 255, 255, 0.1);
                    border-radius: 35px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    transition: transform 0.06s ease, border-color 0.06s ease, box-shadow 0.06s ease;
                    cursor: pointer;
                }

                /* Lado izquierdo (Azul/Cyan) */
                .pad-left.active {
                    transform: scale(0.92) translateY(8px);
                    border-color: #00ffff;
                    box-shadow: 0 0 30px rgba(0, 255, 255, 0.4), inset 0 0 15px rgba(0, 255, 255, 0.3);
                    background: rgba(0, 255, 255, 0.05);
                }

                /* Lado derecho (Rosa/Magenta) */
                .pad-right.active {
                    transform: scale(0.92) translateY(8px);
                    border-color: #ff00ff;
                    box-shadow: 0 0 30px rgba(255, 0, 255, 0.4), inset 0 0 15px rgba(255, 0, 255, 0.3);
                    background: rgba(255, 0, 255, 0.05);
                }

                .bongo-drum-graphic {
                    width: 70%;
                    transition: filter 0.06s ease;
                }

                .pad-left.active .bongo-drum-graphic {
                    filter: drop-shadow(0 0 15px #00ffff) brightness(1.2);
                }

                .pad-right.active .bongo-drum-graphic {
                    filter: drop-shadow(0 0 15px #ff00ff) brightness(1.2);
                }

                .pad-label {
                    margin-top: 3vh;
                    font-size: 1.2rem;
                    font-weight: 700;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    opacity: 0.8;
                    transition: opacity 0.06s ease;
                }

                .pad-left.active .pad-label { color: #00ffff; opacity: 1; }
                .pad-right.active .pad-label { color: #ff00ff; opacity: 1; }

                .bongo-mobile-footer {
                    text-align: center;
                    font-size: 0.75rem;
                    opacity: 0.4;
                    margin-bottom: 2vh;
                    letter-spacing: 1px;
                }
            `}</style>

            <div className="bongo-mobile-header">
                <h1 className="bongo-mobile-title">BONGO CAM</h1>
                <p className="bongo-mobile-subtitle">¡Toca al ritmo de la música!</p>
            </div>

            <div className="bongo-mobile-pads">
                {/* Bongo Izquierdo */}
                <div 
                    className={`bongo-touch-pad pad-left ${leftActive ? 'active' : ''}`}
                    onTouchStart={(e) => { e.preventDefault(); handleHit('left'); }}
                    onMouseDown={() => handleHit('left')}
                >
                    <img 
                        src="/img/overlays/bongo/1.png" 
                        alt="Bongo Izquierdo"
                        className="bongo-drum-graphic"
                        style={{
                            width: '80%',
                            display: 'block',
                            filter: leftActive 
                                ? 'brightness(1.4) drop-shadow(0px 0px 20px rgba(0, 255, 255, 0.8))' 
                                : 'drop-shadow(0px 4px 8px rgba(0,0,0,0.5))',
                            transition: 'transform 0.05s',
                            transform: leftActive ? 'scale(0.92)' : 'none'
                        }}
                    />
                    <span className="pad-label">IZQ</span>
                </div>

                {/* Bongo Derecho */}
                <div 
                    className={`bongo-touch-pad pad-right ${rightActive ? 'active' : ''}`}
                    onTouchStart={(e) => { e.preventDefault(); handleHit('right'); }}
                    onMouseDown={() => handleHit('right')}
                >
                    <img 
                        src="/img/overlays/bongo/2.png" 
                        alt="Bongo Derecho"
                        className="bongo-drum-graphic"
                        style={{
                            width: '80%',
                            display: 'block',
                            filter: rightActive 
                                ? 'brightness(1.4) drop-shadow(0px 0px 20px rgba(255, 0, 255, 0.8))' 
                                : 'drop-shadow(0px 4px 8px rgba(0,0,0,0.5))',
                            transition: 'transform 0.05s',
                            transform: rightActive ? 'scale(0.92)' : 'none'
                        }}
                    />
                    <span className="pad-label">DER</span>
                </div>
            </div>

            <div className="bongo-mobile-footer">
                <span>INTERAKTIA ENTERTAINMENT &copy; 2026</span>
            </div>
        </div>
    );
};
export default BongoMobile;
